module.exports = __webpack_public_path__ + "static/media/grapes.d1c48c63.png";